import { TProductTile } from 'widgets/product/ProductTile';
import { TButtonInstance } from 'widgets/global/Button';

/**
 * @param ProductTile Base widget for extending
 * @returns Quick Buy Product Tile widget
 */
function QuickBuyProductTileMixinClassCreator(ProductTile: TProductTile) {
    /**
     * @category widgets
     * @subcategory plugin_quickbuy
     * @class ProductDetail
     * @augments Widget
     * @classdesc Represents QuickBuyProductTileMixin component with next features:
     * 1. Adds handler for quick buy button click
     */
    class QuickBuyProductTileMixin extends ProductTile {
        /**
         * @description Handles quick buy button click
         * @param button Add to cart button
         * @listens dom#click
         */
        showQuickBuy(button: TButtonInstance) {
            /**
             * @description Event dispatched, when Global Modal should be triggered
             * @event module:events#dialogshow
             */
            this.eventBus().emit('dialogshow', {
                type: 'quickbuy',
                trigger: this.ref('self').get(),
                url: button.data('url'),
                wrapperClasses: 'm-quick_buy',
                bodyClass: 'm-has_popup',
                ariaLabel: this.prefs().productName,
                attributes: {
                    'data-tau-unique': 'quick_buy_dialog'
                }
            }, this.onModalShow.bind(this));
        }
    }

    return QuickBuyProductTileMixin;
}

export type TQuickBuyProductTileMixin = ReturnType<typeof QuickBuyProductTileMixinClassCreator>;

export type TQuickBuyProductTileMixinInstance = InstanceType<TQuickBuyProductTileMixin>;

export default QuickBuyProductTileMixinClassCreator;
